import type { GetMatchesParams } from "@/features/predictions/types/filters.type";

export const PREDICTIONS_QUERY_KEYS = {
  all: ["predictions"] as const,
  competitions: () => ["predictions", "competitions"] as const,
  activeCompetition: () => ["predictions", "competitions", "active"] as const,
  competition: (competitionId: string) => ["predictions", "competitions", competitionId] as const,
  matches: (params?: GetMatchesParams) => ["predictions", "matches", params ?? {}] as const,
  match: (id: string) => ["predictions", "match", id] as const,
  myPredictions: () => ["predictions", "my", "predictions"] as const,
  rankingGlobal: (competitionId?: string) => ["predictions", "ranking", "global", competitionId ?? "current"] as const,
  rankingGlobalInfinite: (competitionId?: string, limit?: number) =>
    ["predictions", "ranking", "global", "infinite", competitionId ?? "current", limit ?? 25] as const,
  participantPredictions: (competitionId?: string, userId?: string) =>
    ["predictions", "participant", competitionId ?? "current", userId ?? "unknown"] as const,
  myStats: () => ["predictions", "stats", "mine"] as const,
  myBadges: () => ["predictions", "badges", "mine"] as const,
  myPreferences: () => ["predictions", "me", "preferences"] as const,
  competitionLots: (competitionId?: string) =>
    ["predictions", "lots", competitionId ?? "current"] as const,
  competitionStandings: (competitionId?: string) =>
    ["predictions", "standings", competitionId ?? "current"] as const,
};
